var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_25330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2097 18.1733C59.2097 27.5135 51.8001 35.3568 41.8935 35.3568C32.4793 35.3568 24.5374 27.5135 24.5374 18.1733C24.5374 8.34671 32.4793 0.988243 41.8935 0.988243C51.8001 0.988243 59.2097 8.34671 59.2097 18.1733ZM71.6134 84C73.5781 84 74.5595 82.5442 74.5595 81.0489V55.0083C74.5595 48.1346 69.1163 42.7169 62.1975 42.7169H22.0819C15.1232 42.7169 9.1875 48.1346 9.1875 55.0083V81.0489C9.1875 82.5442 10.6611 84 12.1756 84H71.6134Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2003 54.1225C56.8436 54.0987 56.4946 54.237 56.248 54.4999L54.3434 56.4115C53.8351 56.943 53.8351 57.7912 54.3434 58.3231L59.6397 63.727L64.9587 58.3231C65.4709 57.7912 65.4709 56.943 64.9587 56.4115L63.149 54.4999C62.91 54.2409 62.5686 54.1025 62.2196 54.1225C61.8629 54.0952 61.5101 54.2344 61.2673 54.4999L59.7118 56.081L58.1791 54.4999C57.9135 54.2505 57.5645 54.1152 57.2003 54.1225Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.2933,
    cy: 18.2824,
    rx: 18.2824,
    ry: 18.2824,
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_25330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.7f93dac9ed3683d07e6c97c5c47da5a3.svg";
export { ForwardRef as ReactComponent };